export var STATUS_REASON_DELIMITER = ',';
export var splitStatusReasons = function (text) {
    return text.split(STATUS_REASON_DELIMITER).flatMap(function (part) { return part.split(/\r?\n/); }).map(function (reason) { return reason.trim(); }).filter(Boolean);
};
var REASON_TEXT_KEYS = ['Reason', 'Value', 'Description', 'Name', 'Label', 'Text'];
var toText = function (item) {
    if (typeof item === 'string')
        return item.trim();
    if (item && typeof item === 'object') {
        var record_1 = item;
        var key = REASON_TEXT_KEYS.find(function (candidate) { return typeof record_1[candidate] === 'string' && String(record_1[candidate]).trim(); });
        return key ? String(record_1[key]).trim() : '';
    }
    return '';
};
export var parseStatusReasonUdf = function (raw) {
    if (raw === undefined || raw === null)
        return [];
    if (Array.isArray(raw))
        return raw.map(toText).filter(Boolean);
    var text = String(raw).trim();
    if (!text)
        return [];
    if (text.startsWith('[') || text.startsWith('{')) {
        try {
            var parsed = JSON.parse(text);
            var list = Array.isArray(parsed) ? parsed : (Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.Reasons) ? parsed.Reasons : [parsed]);
            var reasons = list.map(toText).filter(Boolean);
            if (reasons.length > 0)
                return reasons;
        }
        catch (_a) {
        }
    }
    return splitStatusReasons(text);
};
export var parseStatusReasonUdfEntries = function (raw) {
    var text = typeof raw === 'string' ? raw.trim() : '';
    if (text.startsWith('[') || text.startsWith('{')) {
        try {
            var parsed = JSON.parse(text);
            var list = Array.isArray(parsed) ? parsed : (Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.Reasons) ? parsed.Reasons : [parsed]);
            var entries = list
                .map(function (item) { return ({
                id: item && typeof item === 'object' && item.Id !== undefined && item.Id !== null && String(item.Id) !== '' ? String(item.Id) : undefined,
                text: toText(item),
            }); })
                .filter(function (entry) { return entry.text || entry.id; });
            if (entries.length > 0)
                return entries;
        }
        catch (_a) {
        }
    }
    return parseStatusReasonUdf(raw).map(function (reasonText) { return ({ text: reasonText }); });
};
